export class AndroidLocationService {
    CheckLocationPermissionAsync() {
        if (this.IsAndroidLocationAvailable()) {
            return navigator.AndroidLocation.CheckLocationPermissionAsync();
        }
        return Promise.resolve(false);
    }
    RequestLocationPermissionAsync() {
        if (this.IsAndroidLocationAvailable()) {
            return navigator.AndroidLocation.RequestLocationPermissionAsync();
        }
        return Promise.resolve(false);
    }
    IsAndroidLocationAvailable() {
        return navigator.AndroidLocation !== undefined;
    }
    GetServiceName() {
        return AndroidLocationService.ServiceName;
    }
}
AndroidLocationService.ServiceName = "AndroidLocationService";
//# sourceMappingURL=AndroidLocationService.js.map